import { NIGHT_ASSETS } from "../../config/figmaNightLayout";
import { assetUrl } from "../../utils/assetUrl";
import "./NightDock.css";

const bottomDockSrc = assetUrl(NIGHT_ASSETS.bottomDockSvg);
const qqMusicSrc = assetUrl(NIGHT_ASSETS.qqMusic);

export function NightDock({
  dockSrc = bottomDockSrc,
  musicIconSrc = qqMusicSrc,
  label = "夜间车机底部 Dock"
}: {
  dockSrc?: string;
  musicIconSrc?: string | null;
  label?: string;
}) {
  return (
    <nav className="night-bottom-dock" aria-label={label}>
      <img className="night-bottom-dock__source" src={dockSrc} alt="" draggable={false} aria-hidden="true" />
      {musicIconSrc ? (
        <span className="night-bottom-dock__music-icon" aria-hidden="true">
          <img src={musicIconSrc} alt="" draggable={false} />
        </span>
      ) : null}
    </nav>
  );
}
